/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./improvments.js');
require('./bootstrap.js');
try {
    // share-buttons.js
    require('./share-buttons.js');
} catch (e) {
    console.error('Unable to load share buttons module' + e);
}
try {
    // share-buttons.js
    require('./favored-design.js');
} catch (e) {
    console.error('Unable to load favored button module' + e);
}

try {
    // promo-header.js
    require('./promo-header.js');
} catch (e) {
    console.error('Unable to load promo header module' + e);
}

require('./search-design.js');
require('./payments/payments.js');
require('./user-settings.js');
try {
    // crisp-chat.js
    if(document.getElementsByClassName('headerMainMydesigns').length > 0 && typeof $crisp !== 'undefined') {
        require('./crisp-chat.js');
    }
} catch (e) {
    console.error('Unable to load crisp chat' + e);
}

try {
    // if(jQuery('[data-selection-id]').length > 0) {
        require('./folders/load');
    // }
} catch (e) {
    console.error('Unable to load folders and selections' + e);
}

try{
    navigator.serviceWorker.register('/js/service-worker.js');
}catch (e) {
    console.error('Unable to service-worker.js' + e);
}

try {
    // if(jQuery('[data-selection-id]').length > 0) {
    require('./download/load');
    // }
} catch (e) {
    console.error('Unable to load download and selections' + e);
}

